import { Link } from "react-router-dom";
import { company, navItems } from "../data/site";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <div className="brand footer-logo">
            <span>
              <strong>{company.shortName}</strong>
              <small>{company.englishName}</small>
            </span>
          </div>
          <p>{company.slogan}</p>
          <p className="footer-address">{company.address}</p>
        </div>

        {navItems.map((item) => (
          <div className="footer-col" key={item.path}>
            <h4>
              <Link to={item.path}>{item.label}</Link>
            </h4>
            {item.children ? (
              item.children.map((child) => (
                <Link
                  key={child.label}
                  to={child.tab ? `${child.path}?tab=${child.tab}` : child.path}
                >
                  {child.label}
                </Link>
              ))
            ) : (
              <Link to={item.path}>查看详情</Link>
            )}
          </div>
        ))}

        <div className="footer-col">
          <h4>
            <Link to="/contact">联系我们</Link>
          </h4>
          <a href={`mailto:${company.email}`}>{company.email}</a>
          <a href={company.mapUrl} target="_blank" rel="noreferrer">
            查看地图
          </a>
        </div>
      </div>
      <div className="footer-bar">
        <div className="container">
          <span>版权归属：{company.name}</span>
          <span>Copyright © 2024-{new Date().getFullYear()} All Rights Reserved.</span>
        </div>
      </div>
    </footer>
  );
}
